/* PuntoZero: aggiunta rapida dei prodotti consigliati per la soglia di spedizione gratuita */
(function () {
  if (window.pzSogliaInit) return;
  window.pzSogliaInit = true;

  function euro(cent) {
    return (cent / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
  }

  function prezzoRiga(riga) {
    var sel = riga.querySelector('.pz-soglia__variante');
    if (sel && sel.selectedOptions[0]) return parseInt(sel.selectedOptions[0].dataset.prezzo, 10) || 0;
    return parseInt(riga.dataset.prezzo, 10) || 0;
  }

  function quantita(riga) {
    var q = parseInt(riga.querySelector('.pz-q').value, 10);
    return isNaN(q) || q < 0 ? 0 : Math.min(q, 20);
  }

  function aggiorna(box) {
    var aggiunta = 0, pezzi = 0;
    box.querySelectorAll('.pz-riga').forEach(function (riga) {
      var prezzo = prezzoRiga(riga);
      riga.querySelector('.pz-soglia__prezzo').textContent = euro(prezzo);
      var q = quantita(riga);
      aggiunta += q * prezzo;
      pezzi += q;
    });
    var soglia = parseInt(box.dataset.soglia, 10);
    var totale = parseInt(box.dataset.totale, 10) + aggiunta;
    var resto = soglia - totale;
    var barra = box.querySelector('.pz-soglia__barra span');
    if (barra) barra.style.width = Math.min(100, Math.round((totale * 100) / soglia)) + '%';
    var esito = box.querySelector('.pz-soglia__esito');
    var bottone = box.querySelector('.pz-conferma');
    if (bottone) bottone.disabled = pezzi === 0;
    if (esito) {
      if (pezzi === 0) esito.textContent = '';
      else if (resto > 0) esito.textContent = 'Con questi ti mancano ancora ' + euro(resto);
      else esito.textContent = '✓ Con questi hai la spedizione gratuita';
    }
  }

  document.addEventListener('click', function (e) {
    var piuMeno = e.target.closest('.pz-piu, .pz-meno');
    if (piuMeno) {
      e.preventDefault();
      var riga = piuMeno.closest('.pz-riga');
      var input = riga.querySelector('.pz-q');
      var q = quantita(riga) + (piuMeno.classList.contains('pz-piu') ? 1 : -1);
      input.value = Math.max(0, Math.min(20, q));
      aggiorna(piuMeno.closest('.pz-soglia'));
      return;
    }

    var conferma = e.target.closest('.pz-conferma');
    if (conferma) {
      e.preventDefault();
      var box = conferma.closest('.pz-soglia');
      var items = [];
      box.querySelectorAll('.pz-riga').forEach(function (riga) {
        var q = quantita(riga);
        if (q > 0) {
          var sel = riga.querySelector('.pz-soglia__variante');
          items.push({ id: parseInt(sel ? sel.value : riga.dataset.variante, 10), quantity: q, properties: { _origine: 'barra-soglia' } });
        }
      });
      if (!items.length) return;
      conferma.disabled = true;
      conferma.textContent = 'Aggiungo al carrello…';
      var routes = window.routes || {};
      var carrello = routes.cart_url || '/cart';
      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function () { window.location.href = carrello; })
        .catch(function () { window.location.href = carrello; });
    }
  });

  function suCambio(e) {
    var riga = e.target.closest('.pz-riga');
    if (riga) aggiorna(riga.closest('.pz-soglia'));
  }
  document.addEventListener('change', suCambio);
  document.addEventListener('input', suCambio);
})();

/* PuntoZero: contatore della spedizione gratuita.
   Dopo "Aggiungi al carrello" non si apre più il riquadro di Dawn: si aggiornano l'icona
   del carrello e i contatori (.pz-cont) con una piccola animazione. Se nessun contatore
   è a vista, compare per qualche secondo la barra volante in basso, che sparisce da sola. */
(function () {
  if (window.pzContInit) return;
  window.pzContInit = true;

  /* la barra volante va sotto <body>: dentro l'header sticky "fixed" non funzionerebbe */
  var volanteEl = document.querySelector('.pz-volante');
  if (volanteEl && volanteEl.parentNode !== document.body) document.body.appendChild(volanteEl);

  var ridotto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timerVolante;

  function euro(cent) {
    return (Math.max(0, cent) / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function contaGiu(el, da, a) {
    if (ridotto || da === a) { el.textContent = euro(a); return; }
    var inizio = null, durata = 700;
    function passo(t) {
      if (!inizio) inizio = t;
      var k = Math.min(1, (t - inizio) / durata);
      k = 1 - Math.pow(1 - k, 3);
      el.textContent = euro(Math.round(da + (a - da) * k));
      if (k < 1) requestAnimationFrame(passo);
    }
    requestAnimationFrame(passo);
  }

  function aggiornaUno(box, cart, anima, messaggio) {
    var soglia = parseInt(box.dataset.soglia, 10) || 5000;
    var primaTot = parseInt(box.dataset.totale, 10) || 0;
    var tot = cart.total_price, pezzi = cart.item_count;
    var mancaPrima = soglia - primaTot, manca = soglia - tot;
    box.dataset.totale = tot;
    box.dataset.pezzi = pezzi;

    var testo = box.querySelector('.pz-cont__testo');
    if (pezzi === 0) {
      testo.innerHTML = 'Spedizione gratuita da <strong>' + euro(soglia).replace(',00', '') + '</strong>';
    } else if (manca > 0) {
      var cifra = box.querySelector('.pz-cont__cifra');
      if (!cifra) {
        testo.innerHTML = 'Ti mancano <strong class="pz-cont__cifra"></strong> per la spedizione gratuita';
        cifra = testo.querySelector('.pz-cont__cifra');
      }
      contaGiu(cifra, anima ? Math.max(manca, Math.min(soglia, mancaPrima)) : manca, manca);
    } else {
      testo.innerHTML = '&#10003; Hai la <strong>spedizione gratuita</strong>';
    }
    box.classList.toggle('pz-cont--ok', pezzi > 0 && manca <= 0);

    var link = box.querySelector('.pz-cont__link');
    if (link) {
      link.hidden = pezzi === 0;
      var n = link.querySelector('.pz-cont__pezzi');
      if (n) n.textContent = pezzi;
    }

    var barra = box.querySelector('.pz-cont__barra span');
    if (barra) barra.style.width = Math.min(100, Math.round((tot * 100) / soglia)) + '%';

    if (!anima) return;
    var appenaRaggiunta = mancaPrima > 0 && manca <= 0;
    box.classList.remove('pz-pulsa');
    void box.offsetWidth;
    box.classList.add('pz-pulsa');
    if (appenaRaggiunta) box.classList.add('pz-cont--festa');
    setTimeout(function () { box.classList.remove('pz-pulsa', 'pz-cont--festa'); }, 1600);

    var chip = box.querySelector('.pz-cont__aggiunto');
    if (chip) {
      chip.textContent = appenaRaggiunta ? '🎉 Spedizione gratuita!' : messaggio;
      chip.classList.add('pz-vis');
      clearTimeout(chip._t);
      chip._t = setTimeout(function () { chip.classList.remove('pz-vis'); }, 2600);
    }
  }

  function aVista(el) {
    if (!el.offsetParent && getComputedStyle(el).position !== 'fixed') return false;
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  function aggiornaTutti(cart, anima, messaggio) {
    var visibile = false;
    document.querySelectorAll('.pz-cont').forEach(function (box) {
      if (box.closest('.pz-volante')) return;
      aggiornaUno(box, cart, anima, messaggio);
      if (aVista(box)) visibile = true;
    });
    var volante = document.querySelector('.pz-volante');
    if (!volante) return;
    var boxV = volante.querySelector('.pz-cont');
    if (boxV) aggiornaUno(boxV, cart, anima && !visibile, messaggio);
    if (anima && !visibile) {
      volante.classList.add('pz-vis');
      clearTimeout(timerVolante);
      timerVolante = setTimeout(function () { volante.classList.remove('pz-vis'); }, 4000);
    }
  }

  function leggiCarrello() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(base + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  window.pzAggiornaContatori = function (anima, messaggio) {
    return leggiCarrello().then(function (cart) { aggiornaTutti(cart, anima, messaggio || '✓ Aggiunto'); }).catch(function () {});
  };

  /* Sostituisce il riquadro di Dawn dopo l'aggiunta al carrello */
  if (window.customElements) {
    customElements.whenDefined('cart-notification').then(function () {
      var C = customElements.get('cart-notification');
      if (!C || C.prototype.pzSenzaRiquadro) return;
      C.prototype.pzSenzaRiquadro = true;
      C.prototype.renderContents = function (stato) {
        this.cartItemKey = stato && stato.key;
        try {
          var bolla = document.getElementById('cart-icon-bubble');
          if (bolla && stato.sections && stato.sections['cart-icon-bubble']) {
            bolla.innerHTML = this.getSectionInnerHTML(stato.sections['cart-icon-bubble']);
          }
        } catch (e) {}
        if (this.header && this.header.reveal) this.header.reveal();
        window.pzAggiornaContatori(true, '✓ Aggiunto al carrello');
        var bollaEl = document.getElementById('cart-icon-bubble');
        if (bollaEl && !ridotto && bollaEl.animate) {
          bollaEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'ease-out' });
        }
      };
    });
  }

  /* Torna indietro col browser: la pagina può arrivare dalla cache con totali vecchi */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && document.querySelector('.pz-cont')) window.pzAggiornaContatori(false);
  });
})();
